module.exports = __webpack_public_path__ + "img/totalquestion.8ebd1a25.svg";